import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';
import TabNavigation from '@ts-core/components/TabNavigation';

import ListAltIcon from '@mui/icons-material/ListAlt';

const useStyles = makeStyles((theme) => ({
  titleIcon: {
    fontSize: 72,
  },
  title: {
    marginTop: -theme.spacing(1),
    fontSize: 32,
  },
}));

const AttendancePageHeader = (props) => {
  const { tabs, activeTab, onGoToTab } = props;

  const classes = useStyles();

  return (
    <Box borderBottom={1}>
      <Box textAlign="center" mb={2}>
        <ListAltIcon fontSize="large" className={classes.titleIcon} />
        <Typography variant="h6" className={classes.title}>
          <FormattedMessage id="quickLink.attendanceControl" />
        </Typography>
      </Box>
      <TabNavigation tabs={tabs} activeTab={activeTab} onGoToTab={onGoToTab} />
    </Box>
  );
};

AttendancePageHeader.propTypes = {
  tabs: PropTypes.array,
  activeTab: PropTypes.object,

  onGoToTab: PropTypes.func,
};

AttendancePageHeader.defaultProps = {
  tabs: undefined,
  activeTab: undefined,
  onGoToTab: undefined,
};

export default AttendancePageHeader;
